import React from 'react';
import { NetworkStatus } from '@apollo/client';

import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import { useFundLettersQuery } from 'interfaces/graphql-typings';

import styles from 'buyside/components/presentation/FundLetterIndex/fundLetterStyles.scss';

const FundLetterList: React.FC<{ fundName: string }> = ({ fundName }): React.ReactElement => {
  const { data, error, fetchMore, networkStatus } = useFundLettersQuery({
    variables: { fundName },
    notifyOnNetworkStatusChange: true
  });

  if (error) throw error;

  return (
    <div className={styles.fundLetterList}>
      <h4 className={styles.fundNameHeader}>{fundName}</h4>
      <ul className={styles.linkList}>
        {data?.lettersForFund?.edges?.map((fundLetter, idx) => {
          if (!fundLetter?.node || !fundLetter.node.name || !fundLetter.node.pdfLink) return null;
          const { name, pdfLink } = fundLetter.node;
          return (
            <li key={`${fundName}-${idx}`}>
              <a href={pdfLink} target="_blank" title={name}>
                {name}
              </a>
            </li>
          );
        })}
      </ul>
      {[NetworkStatus.fetchMore, NetworkStatus.loading].includes(networkStatus) &&
        data?.lettersForFund?.pageInfo?.endCursor && <LoadingSpinner size={SIZES.MEDIUM} />}
      {networkStatus === NetworkStatus.ready && data?.lettersForFund?.pageInfo?.hasNextPage && (
        <Button
          id="load-more-fund-letters"
          onClick={(): void => {
            fetchMore({
              variables: {
                cursor: data?.lettersForFund?.pageInfo.endCursor
              }
            });
          }}
          text="Load More"
          type={BUTTON_TYPES.LINK}
          className={styles.loadMoreButton}
        />
      )}
    </div>
  );
};

export default FundLetterList;
